var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 22,
    viewBox: "0 0 66 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 22,
    fill: "#A098AE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_1151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.016 7.524V10.32H20.064V11.22H17.016V14.1H20.424V15H15.924V6.624H20.424V7.524H17.016ZM28.6523 15H27.5603L23.1683 8.34V15H22.0763V6.624H23.1683L27.5603 13.272V6.624H28.6523V15ZM35.6618 6.636V7.524H33.3818V15H32.2898V7.524H29.9978V6.636H35.6618ZM41.41 15L39.418 11.58H38.098V15H37.006V6.636H39.706C40.338 6.636 40.87 6.744 41.302 6.96C41.742 7.176 42.07 7.468 42.286 7.836C42.502 8.204 42.61 8.624 42.61 9.096C42.61 9.672 42.442 10.18 42.106 10.62C41.778 11.06 41.282 11.352 40.618 11.496L42.718 15H41.41ZM38.098 10.704H39.706C40.298 10.704 40.742 10.56 41.038 10.272C41.334 9.976 41.482 9.584 41.482 9.096C41.482 8.6 41.334 8.216 41.038 7.944C40.75 7.672 40.306 7.536 39.706 7.536H38.098V10.704ZM50.1628 6.636L47.4388 11.844V15H46.3468V11.844L43.6108 6.636H44.8228L46.8868 10.872L48.9508 6.636H50.1628Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_1151",
    x: 11.924,
    y: 3.62305,
    width: 42.2389,
    height: 16.377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_1151"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_1151",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntry);
export default __webpack_public_path__ + "static/media/entry.e34b8da46ecf3e2399f68328f357a68a.svg";
export { ForwardRef as ReactComponent };